import { QuickLinks, Types } from '.'
import { EJ } from '../../../constants/CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'

export const EJLog = new CIMSPageItem({
  id: '603F6D4D-5447-4D5F-B3FA-CFE2AE97AC5E',
  name: 'EJ Log',
  pathname: 'log',
  module: EJ,
  linkable: true,
})

export const EJTypes = Types({
  id: '88FF8C61-01F0-4CEF-8129-6969DB8CDE78',
  module: EJ,
})

export const EJNotifications = new CIMSPageItem({
  id: 'D8AE855D-AE61-4F53-94D7-5FCD2266B585',
  name: 'Notifications',
  pathname: 'notifications',
  module: EJ,
})

export const EJQuickLinks = QuickLinks({
  id: '5DE2C91F-D2F9-40A8-BFAF-A126526CA134',
  module: EJ,
})

export type EJPageItem =
  | typeof EJLog
  | typeof EJTypes
  | typeof EJNotifications
  | typeof EJQuickLinks
